import {get, post} from 'external/axios';

export class PackageService {
	async getPackageByClientId(clientId) {
        return get(`/homeschooler/purchase/client/${clientId}`);
    }
}

export const packageService = new PackageService();